(() => {
  if (window.AmabimbiCourseDateSortReady) return;
  window.AmabimbiCourseDateSortReady = true;

  const parsedDate = (rawDate) => {
    const timestamp = Date.parse(rawDate);
    return Number.isNaN(timestamp) ? Number.POSITIVE_INFINITY : timestamp;
  };

  const elementsInScope = (scope, selector) => {
    const elements = [];
    if (scope instanceof Element && scope.matches(selector)) elements.push(scope);
    if (scope.querySelectorAll) elements.push(...scope.querySelectorAll(selector));
    return elements;
  };

  const sortChildren = (list, children, dateForChild) => {
    if (children.length < 2) return;

    const sortedChildren = children
      .map((child, index) => ({ child, index, date: parsedDate(dateForChild(child)) }))
      .sort((first, second) => {
        if (first.date !== second.date) return first.date - second.date;
        return first.index - second.index;
      })
      .map(({ child }) => child);

    const orderChanged = sortedChildren.some((child, index) => child !== children[index]);
    if (orderChanged) sortedChildren.forEach((child) => list.appendChild(child));
  };

  const sortCourseDateLists = (scope) => {
    elementsInScope(scope, '[data-course-date-list]').forEach((list) => {
      const cards = Array.from(list.children).filter((item) => item.matches('[data-course-date-card]'));
      sortChildren(list, cards, (card) => card.dataset.courseDate || '');
    });
  };

  const sortProductGrids = (scope) => {
    elementsInScope(scope, '.product-grid').forEach((list) => {
      const cards = Array.from(list.children).filter((item) => item.querySelector('[data-course-product-card]'));

      sortChildren(list, cards, (card) => {
        const productCard = card.querySelector('[data-course-product-card]');
        return productCard ? productCard.dataset.courseDate || '' : '';
      });
    });
  };

  const sortCourseDates = (scope = document) => {
    sortCourseDateLists(scope);
    sortProductGrids(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sortCourseDates(), { once: true });
  } else {
    sortCourseDates();
  }

  document.addEventListener('shopify:section:load', (event) => sortCourseDates(event.target));

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) sortCourseDates(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
